// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout.css - Remove Background and Adjust Layout */
.layout-header {
  display: flex;
  flex-direction: column; /* Stack elements vertically */
  align-items: flex-end; /* Align elements to the right */
  padding: 10px 20px;
  background-color: transparent;
  border-bottom: none;
  
}

.logout-section {
  display: flex;
  flex-direction: row; /* Keep elements in the same row */
  align-items: center; /* Ensure all elements align properly */
  gap: 10px; /* Add space between dropdown and button */
  margin-bottom: 5px; /* Space before breadcrumbs */
}

/* Ensures the dropdown and label are properly aligned */
.tenant-selection-container {
  display: flex;
  flex-direction: row;
  align-items: center; /* Align label and dropdown */
  gap: 5px; /* Adjust spacing */
 
}
.tenant-selection-container label {
  font-size: 12px; /* Make label text smaller */
  white-space: nowrap; /* Prevent wrapping */
}

.tenant-selection-container select {
  width: 150px; /* Adjust width of the dropdown */
  padding: 4px 8px; /* Reduce padding */
  font-size: 14px; /* Make text smaller */
  background-color: #e0e0e0;
}

.breadcrumbs-container {
  align-self: flex-start; /* Align breadcrumbs to the left */
  width: 100%;
  margin-top: 5px;
}


.logout-button {
  padding: 8px 12px;
  background-color: #741c25;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  margin-bottom: 18px;
  margin-left: 5px;
}

.logout-button:hover {
  background-color: #c82333;
}

.page-content {
  margin: 20px; 
}

.tenant-selector {
  position: relative;
  display: inline-block;
  margin-right: 20px;
}

.tenant-button {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 5px;
}

.tenant-dropdown {
  position: absolute;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 150px;
  top: 40px;
  right: 0;
  z-index: 1000;
  
  
}

.tenant-item {
  padding: 10px;
  cursor: pointer;
  
}

.tenant-item:hover {
  background: #f1f1f1;
}

.logout-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  outline: none;
}

.logout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logout-modal-content {
  text-align: center;
}

.logout-modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 10px;
}

.logout-modal-buttons button {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.logout-modal-buttons button:first-child {
  background-color: #dc3545;
  color: white;
  border: none;
}

.logout-modal-buttons button:last-child {
  background-color: #6c757d;
  color: white;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Layout.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB,EAAE,8BAA8B;EACtD,qBAAqB,EAAE,gCAAgC;EACvD,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,kCAAkC;EACvD,mBAAmB,EAAE,uCAAuC;EAC5D,SAAS,EAAE,0CAA0C;EACrD,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB,EAAE,6BAA6B;EAClD,QAAQ,EAAE,mBAAmB;;AAE/B;AACA;EACE,eAAe,EAAE,4BAA4B;EAC7C,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,YAAY,EAAE,iCAAiC;EAC/C,gBAAgB,EAAE,mBAAmB;EACrC,eAAe,EAAE,sBAAsB;EACvC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;EAC1D,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,aAAa;;;AAGf;;AAEA;EACE,aAAa;EACb,eAAe;;AAEjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd","sourcesContent":["/* Layout.css - Remove Background and Adjust Layout */\n.layout-header {\n  display: flex;\n  flex-direction: column; /* Stack elements vertically */\n  align-items: flex-end; /* Align elements to the right */\n  padding: 10px 20px;\n  background-color: transparent;\n  border-bottom: none;\n  \n}\n\n.logout-section {\n  display: flex;\n  flex-direction: row; /* Keep elements in the same row */\n  align-items: center; /* Ensure all elements align properly */\n  gap: 10px; /* Add space between dropdown and button */\n  margin-bottom: 5px; /* Space before breadcrumbs */\n}\n\n/* Ensures the dropdown and label are properly aligned */\n.tenant-selection-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center; /* Align label and dropdown */\n  gap: 5px; /* Adjust spacing */\n \n}\n.tenant-selection-container label {\n  font-size: 12px; /* Make label text smaller */\n  white-space: nowrap; /* Prevent wrapping */\n}\n\n.tenant-selection-container select {\n  width: 150px; /* Adjust width of the dropdown */\n  padding: 4px 8px; /* Reduce padding */\n  font-size: 14px; /* Make text smaller */\n  background-color: #e0e0e0;\n}\n\n.breadcrumbs-container {\n  align-self: flex-start; /* Align breadcrumbs to the left */\n  width: 100%;\n  margin-top: 5px;\n}\n\n\n.logout-button {\n  padding: 8px 12px;\n  background-color: #741c25;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  margin-bottom: 18px;\n  margin-left: 5px;\n}\n\n.logout-button:hover {\n  background-color: #c82333;\n}\n\n.page-content {\n  margin: 20px; \n}\n\n.tenant-selector {\n  position: relative;\n  display: inline-block;\n  margin-right: 20px;\n}\n\n.tenant-button {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.tenant-dropdown {\n  position: absolute;\n  background: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  width: 150px;\n  top: 40px;\n  right: 0;\n  z-index: 1000;\n  \n  \n}\n\n.tenant-item {\n  padding: 10px;\n  cursor: pointer;\n  \n}\n\n.tenant-item:hover {\n  background: #f1f1f1;\n}\n\n.logout-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\n.logout-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logout-modal-content {\n  text-align: center;\n}\n\n.logout-modal-buttons {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n\n.logout-modal-buttons button {\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.logout-modal-buttons button:first-child {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n}\n\n.logout-modal-buttons button:last-child {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
